/**
 * Escape a JSON string for safe embedding inside an HTML <script> tag.
 *
 * Prevents XSS via:
 * - </script> injection (escape </)
 * - HTML comment breakout (escape <!--)
 * - Unicode line terminators (U+2028, U+2029)
 */
export function escapeJsonForHtml(json: string): string {
  return json
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");
}
